/**
 * Created by PhpStorm on 08.05.2017.
 * Author: Shabalin Pavel
 * Email: aisamiery@gmail.com
 */
'use strict';

angular.module('far.subclub')
    .controller('SubclubEditController', function($window, autocomplete, Subclub, subclubEditForm, http, showModalMessage) {

        var vm = {
            progress: true,
            submitted: false,
            show_error: true,
            subclub: null,
            form: {},
            fields: subclubEditForm,
            constructor: function (subclub) {
                if ( subclub ) {
                    vm.form = Subclub.get(subclub, function() {
                        if ( vm.form.country ) {
                            vm.form.country = {
                                name: vm.form.country
                            };

                            vm.fields.autoCompleteSelect.country = vm.form.country_id;
                        }

                        if ( vm.form.region ) {
                            vm.form.region = {
                                name: vm.form.region
                            };
                        }

                        if ( vm.form.city ) {
                            vm.form.city = {
                                name: vm.form.city
                            };
                        }

                        if ( vm.form.parent ) {
                            vm.form.club = {
                                'id': vm.form.parent.id,
                                'name': vm.form.parent.name
                            };
                        }

                        vm.progress = false;
                    });
                } else {
                    vm.form = Subclub.new({country: {
                        name: 'Россия',
                        id: 150
                    }});

                    vm.fields.autoCompleteSelect.country = 150;

                    vm.progress = false;
                }
            },
            submit: function (form) {
                if ( vm.submitted ) {
                    return false;
                }

                if (form.$valid) {
                    vm.submitted = true;
                    vm.progress = true;

                    vm.form.save().then(
                        function (response) {
                            // Успешно сохранили
                            document.location.href=Routing.generate('club_members', {id: response.data.id});
                        },
                        function (response) {
                            response = http.authenticationListener(response);
                            vm.submitted = false;
                            vm.progress = false;
                        }
                    );
                } else {
                    showModalMessage('Форма заполнена не корректно');
                }
            }
        };

        vm.fields.$fields.user.uiSelectOptions.onSelect = function(item) {
            if (item) { vm.form.user = item; }
        };
        vm.fields.$fields.club.uiSelectOptions.onSelect = function(item) {
            if (item) { vm.form.club = item; }
        };
        vm.fields.$fields.avatar.uploader.onSuccessItem= function (item, response) {
            vm.form.avatar = response;
        };
        vm.fields.$fields.country.uiSelectOptions.onSelect = function(item) {
            if (item) { vm.form.country = item; }
        };
        vm.fields.$fields.region.uiSelectOptions.onSelect = function(item) {
            if (item) { vm.form.region = item; }
        };
        vm.fields.$fields.city.uiSelectOptions.onSelect = function(item) {
            if (item) { vm.form.city = item; }
        };

        return vm;
    });